import { getDefaultTableOptions } from '../../../../../../Services/SharedService';

const defaultTableOptions = getDefaultTableOptions();

export const getTableOptions = (pageSize, pageSizeOptions) => ({
  ...defaultTableOptions,
  actionsColumnIndex: -1,
  headerStyle: {
    ...defaultTableOptions.headerStyle,
    fontFamily: '"Open Sans", Helvetica, Arial, sans-serif',
    lineHeight: '24px',
    padding: '16px 24px 16px 16px',
    whiteSpace: 'nowrap',
  },
  paging: true,
  emptyRowsWhenPaging: false,
  pageSize,
  pageSizeOptions,
  showFirstLastPageButtons: false,
  rowStyle: {
    minWidth: '1048px',
  },
});
